// Function to fade out the entire page
function fadeOutPage(targetUrl) {
  gsap.to("body", {
    opacity: 0,
    duration: 0.3,
    ease: "power2.inOut",
    onComplete: () => {
      window.location.href = targetUrl;
    }
  });
}

// Attach the event listener to intercept all link clicks
document.querySelectorAll("a").forEach(link => {
  link.addEventListener("click", function (e) {
    // Optional: Skip external links or links that shouldn't have the fade out effect
    // Example: if (!this.href.includes(window.location.host)) return;
    
    e.preventDefault();
    fadeOutPage(this.href);
  });
});
// End function to fade out the entire page

const ease = "power2.inOut";
const duration = 0.7;

const animations = {
  // Fade in elements
  toFade: {
    duration,
    ease,
    opacity: 1,
    stagger: 0.02,
  },

  // Fade for grid backgrounds
  fromFadeGrid: {
    backgroundColor: "transparent",
    delay: 0.02,
    duration,
    ease,
  },

  // Fade-in menu items
  toFadeMenuItem: {
    delay: 0.1,
    ease,
    opacity: 1,
    stagger: 0.06,
  },

  // Renamed to toScrambubble (no mention of H1)
  toScrambubble: {
    duration: 1.5,
    overwrite: true,
    scrambleText: {
      chars: "0123456789!",
      text: "{original}",
      tweenLength: false,
    },
  },
};

const selectors = {
  // Elements to fade in
  fadeInElements: [
    // Products & services
    "li",

    // Explicitly added elements
    ".js-fade-in",

    // Product page
    ".product-content-container",

    // Side scrolling top bar
    "section[id*=announcement-bar], scrolling-items-content",

    // Top navigation, including currency converter & actions
    "header, .featured-navigation, nav a, nav button",
  ].join(", "),

  // Drawer elements
  fadeInDrawerElements(prefix) {
    const el = [
      "form",
      "h1",
      "li",
      "label",
      "textarea",
      "dl",
      "dl + p",
      "button",
      ".js-fade-in",
      ".border-gridline-color",
      ".additional-checkout-buttons",
    ];
    return el.map((e) => `${prefix} ${e}`).join(", ");
  },
  // Used to detect grid backgrounds
  isGridBackground: ($el) => $el.classList.value.includes("bg-gridline-color"),
  gridBackground: ".bg-gridline-color, .lg\\:bg-gridline-color",

  // Fade in by group to speed up animation
  isFadeInContainer: ($el) =>
    $el.classList.value.includes("js-fadein-container"),
  fadeinContainer: ".js-fadein-container",

  scrambubble: ".scrambubble",
};

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrambleTextPlugin);
  gsap.registerPlugin(ScrollTrigger);

  enableSmoothScroll();
  gsapAnimateOnScroll();

  // Expose methods globally if needed
  window.theme.gsapAnimateOnScroll = gsapAnimateOnScroll;
  window.theme.gsapAnimateFadeInDrawer = gsapAnimateFadeInDrawer;
});

function enableSmoothScroll() {
  // Initialize Lenis for smooth scrolling
  const lenis = new Lenis();
  lenis.on("scroll", ScrollTrigger.update);

  // Tie Lenis scrolling to GSAP's ticker
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // GSAP time is in seconds, convert to ms
  });
  // Disable lag smoothing to avoid delays in scroll animations
  gsap.ticker.lagSmoothing(0);
}

function hideElements(selector) {
  gsap.set(selector, { opacity: 0 });
}

/**
 * Scramble only elements with the .scrambubble class
 */
function scrambleScrambubble($el, timeline) {
  const $scrambubble = $el.querySelectorAll(selectors.scrambubble);
  if (!$scrambubble.length) return;

  // Use the toScrambubble settings
  timeline.to($scrambubble, animations.toScrambubble, "<");
}

/**
 * Animate elements on scroll.
 * This also supports asynchronously loaded sections.
 */
function gsapAnimateOnScroll(parentSelector = "body") {
  const selector = [selectors.fadeInElements, selectors.gridBackground]
    .join(", ")
    .split(", ")
    .map((s) => `${parentSelector} ${s}`)
    .join(", ");

  // First, make elements invisible, so that quickly scrolling won't cause a content flash
  hideElements(selectors.fadeInElements);

  ScrollTrigger.batch(selector, {
    once: true,
    onEnter($elements) {
      // Remove .preload so elements are visible for animation
      document.body.classList.remove("preload");

      // Separate out grid backgrounds from other elements
      const $grids = $elements.filter(selectors.isGridBackground);
      const gridTweens = $grids.map(($el) =>
        gsap.from($el, { ...animations.fromFadeGrid, paused: true })
      );
      const timeline = gsap.timeline({
        onComplete() {
          // After other animations, fade in grid backgrounds
          gridTweens.forEach((tween) => tween.resume());
        },
      });

      // Separate out .js-fadein-container grids
      const $lastContainerItemsMap = $grids.reduce((map, $container, i) => {
        if (!selectors.isFadeInContainer($container)) {
          return map;
        }

        // Once this last element is animating, we can fade in the grid background
        const $lastEl = [
          ...$container.querySelectorAll(selectors.fadeInElements),
        ].pop();

        return map.set($lastEl, gridTweens[i]);
      }, new Map());

      // Separate out regular elements
      const $fadeInElements = $elements.filter(($el) => !$grids.includes($el));

      // Fade In Elements
      $fadeInElements.forEach(($el) => {
        timeline.to(
          $el,
          {
            ...animations.toFade,
            onStart() {
              const showGridTween = $lastContainerItemsMap.get($el);
              showGridTween &&
                console.log({
                  element: $el,
                });
              showGridTween?.resume();
            },
          },
          `<+=${animations.toFade.stagger}`
        );

        // Apply scramble effect to .scrambubble
        scrambleScrambubble($el, timeline);
      });
    },
  });
}

/**
 * Fade-in for cart & menu sidebars.
 */
function gsapAnimateFadeInDrawer(parentSelector) {
  const selector = selectors.fadeInDrawerElements(parentSelector);
  hideElements(selector);
  const cartTimeline = gsap.timeline({ defaults: { overwrite: true } });
  cartTimeline.to(selector, animations.toFadeMenuItem);
}
